// CheckoutForm.js
import React from 'react';
import PropTypes from 'prop-types'
import { MAIN_CONFIG } from '../../../../config/main'
import { injectStripe, Elements, CardNumberElement } from 'react-stripe-elements';
import { isEmpty } from 'lodash';
import Field from '../../Field/Field'
import { formatDate, isValidDate } from '../../../Utility/FormatDate';
import { parseHtml, formatCurrency, onRadio } from '../../../Utility/HelperFunctions';
import CardSection from '../CardSection/CardSection';
import Cleave from 'cleave.js/react';
import Check from '../../SVG/Check'
import PaymentGatewayVisa from '../../SVG/PaymentGatewayVisa';
import PaymentGatewayMasterCard from '../../SVG/PaymentGatewayMasterCard';
import PaymentGatewayDiscover from '../../SVG/PaymentGatewayDiscover';
import PaymentGatewayDinersClub from '../../SVG/PaymentGatewayDinersClub';
import PaymentGatewayJCB from '../../SVG/PaymentGatewayJCB';
import './Stripe.scss';
import { CreateOptions } from '../../../Utility/SelectListLoader';
import cookies from 'next-cookies';
import CTAButton from '../../CTAButton/CTAButton';
import { blankSpaceCheck, checkFieldLength } from '../../../Utility/ApplicationFormUtility';
import { toast } from 'react-toastify';
import FlashMessage from '../../../Components/FlashMessage/Message'

class Stripe extends React.Component {
  instance;

  constructor(props) {
    super(props);
    let data = props.application;
    const processAmount = (data.processing_fee_field_visibility__c && data.minimum_donation_amount_visible__c) ? ((data.minimum_donation_amount__c || 0 * 3) / 100) : 0
    // const processAmount = (data.processing_amount_in_percent__c > 0) ? ((data.minimum_donation_amount__c || 100) * data.processing_amount_in_percent__c / 100) : (data.processing_amount__c || 5)
    this.state = {
      errors: {},
      alert: null,
      success: '',
      start_date: '',
      first_payment_date: '',
      currentTab: 'One-Time-tab',
      perpetual: false,
      planId: null,
      frequency: 'day',
      no_of_payments: 4,
      hasAllValues: false,
      otherAmount: false,
      include_processing_fee: (data.processing_fee_field_visibility__c && data.minimum_donation_amount_visible__c) || false,
      processing_fee_amount: parseInt(processAmount, 10),
      total_amount: props.hideMinimumAmount ? "" : data.minimum_donation_amount_visible__c ? (data.minimum_donation_amount__c || data.amount_to_pay) : data.amount_to_pay,
      isActive: false,
      card_holder_name: ''
    }
    this.updateErrors = this.updateErrors.bind(this);
  }

  // handlAmountValueChange = (event) => {
  //   const decimal = event.target.value.split('.')
  //   var numberPattern = /\d+/g;
  //   const { data } = this.props.application;
  //   let value = (decimal[0].match(numberPattern) || []).join('')
  //   value = (decimal.length > 1) ? `${value}.${decimal[1]}` : value
  //   this.setState({ [event.target.name]: value, processing_fee_amount: ((data.processing_amount_in_percent > 0) ? ((value * data.processing_amount_in_percent) / 100) : this.state.processing_fee_amount) })
  // }


  onChangeAmount = (name, values, radio) => {

    let value = 0
    if (radio) {
      this.setState({ otherAmount: false })
      // return false
    }
    let data = this.props.application;

    if (typeof (values) !== 'number') {
      var numberPattern = /\d+/g;
      const decimal = values.split('.')
      value = (decimal[0].match(numberPattern) || []).join('')
      value = (decimal.length > 1) ? `${value}.${decimal[1]}` : value
    } else {
      value = values
    }
    this.setState({
      [name]: value,
      processing_fee_amount: ((data.processing_fee_field_visibility__c && data.minimum_donation_amount_visible__c) ? ((value * 3) / 100) : this.state.processing_fee_amount)
      // processing_fee_amount: ((data.processing_amount_in_percent__c > 0) ? ((value * data.processing_amount_in_percent__c) / 100) : this.state.processing_fee_amount)
    })
  }

  onChange = (name, value) => {
    this.setState({ [name]: value })
  }

  handlFieldValueChange = (event) => {
    let data = this.props.application;
    const value = (event.target.type === 'checkbox') ? event.target.checked : event.target.value
    let otherAmount = this.state.otherAmount;
    if (event.target.type === 'radio') {
      otherAmount = false
    }

    let newState = Object.assign({}, this.state);
    if (event.target.name === 'planId') {
      const plan = (data.braintree_plans || []).find(plan => plan.id === event.target.value)
      newState.total_amount = plan ? plan.price : 0
    }
    newState[event.target.name] = formatDate(value)
    newState.errors[event.target.name] = ''
    newState.otherAmount = otherAmount
    // newState.processing_fee_amount = ((data.processing_amount_in_percent__c > 0) ? ((otherAmount * data.processing_amount_in_percent__c) / 100) : this.state.processing_fee_amount__c)

    this.setState(newState)
  }

  handleOtherAmount = (e) => {
    this.setState({ otherAmount: true })
  }

  handleTabChange = (event) => {
    this.setState({ currentTab: event.target.id, hasAllValues: false })
  }

  updateErrors(errors, hasAllValues = true) {
    this.setState({ errors, hasAllValues })
  }

  validateInput(data) {
    const { application } = this.props;
    const isRecurring = (data.currentTab === 'Recurring-tab');

    let errors = {};

    if ((data.total_amount < (application.minimum_donation_amount__c || 0)) && application.minimum_donation_amount_visible__c) {
      errors.total_amount = `Please enter amount greater than or equal to $${(application.minimum_donation_amount__c || 0)}.`
    }
    if (!this.state.card_holder_name) {
      errors.card_holder_name = `Please enter the name.`
    }

    if (isRecurring) {

      if (isEmpty(data.first_payment_date)) {
        errors.first_payment_date = "Please enter date.";
      } else {
        let today = new Date();
        today.setHours(0, 0, 0, 0)
        if (!(new Date(data.first_payment_date) >= today)) {
          errors.first_payment_date = 'Please enter valid future date.';
        }
      }

      if (!isValidDate(data.first_payment_date)) {
        errors.first_payment_date = 'Please enter your date.';

        const splits = (data.first_payment_date || '').split('/')
        const year = splits[splits.length - 1]
        if (parseInt(year, 10) < 1900 || parseInt(year, 10) > 2100) {
          errors.first_payment_date = 'Please enter your valid date.';
        }
      }

    }

    return {
      errors,
      isValid: isEmpty(errors)
    }
  }

  async buy() {
    // Send the nonce to your server
    const { nonce } = await this.instance.requestPaymentMethod();
    await fetch(`server.test/purchase/${nonce}`);
  }

  getAmount = () => {
    const { total_amount, include_processing_fee } = this.state;
    const { application: { minimum_donation_amount_visible__c, processing_fee_field_visibility__c } } = this.props;
    let amountVal = minimum_donation_amount_visible__c && processing_fee_field_visibility__c ? (Math.round((total_amount || 0)) + Math.round((total_amount * 3) / 100)) : (total_amount)
    // let amountVal = include_processing_fee ? ((Math.round((total_amount || 0)) + ((application.processing_amount_in_percent__c > 0) ? Math.round((total_amount * application.processing_amount_in_percent__c) / 100) : Math.round((application.processing_amount__c || 5))))) : (total_amount)
    return amountVal ? "$" + formatCurrency(amountVal) : ''
  }

  getTotalAmount = () => {
    const { total_amount, include_processing_fee } = this.state;
    const { application: { minimum_donation_amount_visible__c, processing_fee_field_visibility__c } } = this.props;
    let amountVal = minimum_donation_amount_visible__c && processing_fee_field_visibility__c ? (Math.round((total_amount || 0)) + Math.round((total_amount * 3) / 100)) : (total_amount)
    // let amountVal = include_processing_fee ? ((Math.round((total_amount || 0)) + ((application.processing_amount_in_percent__c > 0) ? Math.round((total_amount * application.processing_amount_in_percent__c) / 100) : Math.round((application.processing_amount__c || 5))))) : (total_amount)
    return amountVal
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    } else {
      this.setState({ errors })
    }

    return isValid;
  }



  handleSubmit = async (ev) => {
    ev.preventDefault();
    const isRecurring = (this.state.currentTab === 'Recurring-tab');
    const { fieldData, setLoading, accountData, formType } = this.props;
    if (!accountData.token && formType === "Donation Form") {
      let firstName = '';
      let lastName = '';
      let email = '';
    
      for (const question of fieldData) {
        if (question.config_type__c == 'Field') {
          const check = (question.salesforce_field_value__c || '')?.split(';');
          if (check.includes('Application__c.First_Name__c')) {
            firstName = question.answer;
          } else if (check.includes('Application__c.Last_Name__c')) {
            lastName = question.answer;
          } else if (check.includes('Application__c.Email_Address__c')) {
            email = question.answer;
          }
        }
      }
      
      if (blankSpaceCheck(firstName, lastName)) {
        toast.error(<FlashMessage type={'error'} message="You can't add spaces at the beginning of the first name or last name." />);
        return false;
      } else if (!firstName || !lastName || !email) {
        toast.error(<FlashMessage type={'error'} message="First name, last name, or email can't be blank." />);
        return false;
      } else if (checkFieldLength(firstName, 40)) {
        toast.error(<FlashMessage type={'error'} message="First name must be less than 40 characters." />);
        return false;
      } else if (checkFieldLength(lastName, 80)) {
        toast.error(<FlashMessage type={'error'} message="Last name must be less than 80 characters." />);
        return false;
      } else if (checkFieldLength(email, 80)) {
        toast.error(<FlashMessage type={'error'} message="Email must be less than 80 characters." />);
        return false;
      }
    }
    
    if (this.isValid() && this.props.validationCheck(this.props.fieldData)) {
        this.props.setLoading(true)

      const { application } = this.props;
      const { planId } = this.state;
      let processAmount = 0;
      const { card_holder_name, perpetual, frequency, no_of_payments, first_payment_date, include_processing_fee, total_amount, processing_fee_amount } = this.state;
      const recurring = isRecurring ? "Recurring" : "One-Time";
      let paymentDetails = {};
      const {minimum_donation_amount_visible__c, processing_fee_field_visibility__c} = application
      processAmount = (processing_fee_field_visibility__c && minimum_donation_amount_visible__c) ? ((total_amount * 3) / 100) : 0
      if (isRecurring) {
        // processAmount = (application.processing_amount_in_percent__c > 0) ? ((total_amount * application.processing_amount_in_percent__c) / 100) : (application.processing_amount__c || 5)
        paymentDetails = {
          perpetual,
          frequency: frequency ? frequency.value : '',
          no_of_payments: no_of_payments ? no_of_payments.value : '',
          first_payment_date,
          include_processing_fee,
          total_amount: this.getTotalAmount(),
          processing_fee_amount: Math.round(processAmount)
        }
      } else {
        // processAmount = (application.processing_amount_in_percent__c > 0) ? ((total_amount * application.processing_amount_in_percent__c) / 100) : (application.processing_amount__c || 5)
        paymentDetails = {
          include_processing_fee,
          total_amount: this.getTotalAmount(),
          processing_fee_amount: Math.round(processAmount)
        }
      }

      const res = await this.props.stripe.createToken({ name: card_holder_name })
      if (res.error) {
        this.setState({ success: res.error.message })
        this.props.setLoading(false)
      } else if (isEmpty(Object.values(this.state.errors).filter(a => a))) {

        let paymentData = {
          cardInfo: {
            plan_id: planId,
            token: res.token ? res.token : res.nonce,
            paymentDetails,
            recurring: isRecurring ? recurring : null
          }
        }
        this.props.submitPayment(paymentData)
      }
    }else{
      this.props.setLoading(false)
    }

  };

  toggle = () => {
    this.setState({ isActive: !this.state.isActive })
  }

  render() {
    const { application, hideMinimumAmount } = this.props;
    const { card_holder_name, errors, currentTab, perpetual, frequency, no_of_payments, processing_fee_amount, total_amount, include_processing_fee, hasAllValues } = this.state;

    const customAmountVisible = application.minimum_donation_amount_visible__c;
    const customProcessingVisible = application.processing_fee_field_visibility__c;
    var amountOptions = Array(5).fill(application.minimum_donation_amount__c || 100).map((x, y) => x + y * 100)
  
    return (
      <fieldset className={`application__form-section application-section ${this.state.isActive ? 'is-active' : ''}`}>
        {this.props.formType !== "Donation Form" && <legend className="application-section__title">
          {parseHtml(this.props.title)}
          <span className="application-section__completed-badge"><Check />,</span>
        </legend>}
        {this.props.subTitle && <small className="application-section__subtitle">{parseHtml(this.props.subTitle)}</small>}
        <div className="application-section__content">
          <div className="stripe-payment-gateway">
            <div className="stripe-payment-gateway__container">
              {application.allow_recurring_payment__c &&
                <ul className="stripe-payment-gateway__container__select-payment-frequency-tab" role="tablist">
                  <li className="stripe-payment-gateway__container__select-payment-frequency-tab__one-time">
                    <a className={currentTab === 'One-Time-tab' ? "nav-link active" : "nav-link"} id="One-Time-tab" data-toggle="tab" href="#One-Time" role="tab" aria-controls="One-Time" aria-selected="true" onClick={this.handleTabChange}>One-Time</a>
                  </li>

                  <li className="stripe-payment-gateway__container__select-payment-frequency-tab__recurring">
                    <a className={currentTab === 'Recurring-tab' ? "nav-link active" : "nav-link"} id="Recurring-tab" data-toggle="tab" href="#Recurring" role="tab" aria-controls="Recurring" aria-selected="false" onClick={this.handleTabChange}>Recurring</a>
                  </li>
                </ul>
              }

              <div className="stripe-payment-gateway__container__card-user-details">

                <div className="tab-pane fade show active" id="One-Time" role="tabpanel" aria-labelledby="One-Time-tab">
                  {
                    (currentTab === 'One-Time-tab') ? (

                      <form onSubmit={this.handleSubmit}>
                        <div className="stripe-payment-gateway__container__card-type">
                          <PaymentGatewayVisa className="icon-visa" />
                          <PaymentGatewayMasterCard className="icon-master-card" />
                          <PaymentGatewayDiscover className="icon-discover" />
                          <PaymentGatewayDinersClub className="icon-diners-club" />
                          <PaymentGatewayJCB className="icon-jcb" />
                        </div>

                        <div className="section group">
                          <div className="col span_12_of_12">
                            <div className="payment-msg">{this.state.success}</div>
                          </div>
                        </div>

                        <div className={`section group card-holder-name-field ${customAmountVisible ? 'custom-amount-visible-true' : 'custom-amount-visible-false'}`}>
                          <div className="col span_6_of_12">
                          <label className='CTAGrey custom-input-label'>Cardholder Name<span className='add-red-asterisk'>*</span></label>
                            <input
                              type='text'
                              id='card_holder_name'
                              placeholder='Cardholder Name'
                              value={card_holder_name}
                              onChange={this.handlFieldValueChange}
                              name="card_holder_name"
                            />
                            <span className="form-error is-visible">{errors.card_holder_name}</span>
                            <CardSection
                                errors={this.state.errors}
                                updateErrors={this.updateErrors} />
                        </div>
                        <div className='col span_6_of_12'>
                            {
                              customAmountVisible ? (
                                <div className="form-group one-time-payment-amount">
                                  <div className="">
                                  <label className='CTAGrey custom-input-label'>Amount<span className='add-red-asterisk'>*</span></label>
                                    <Field
                                      type='money'
                                      value={hideMinimumAmount ? '' : `$ ${formatCurrency(total_amount)}`}
                                      handleChange={(val) => this.onChangeAmount('total_amount', val, false)}
                                      id="amount"
                                      placeholder="Amount"
                                    />
                                  </div>
                                  <span className="form-error is-visible">{errors.total_amount}</span>
                                </div>
                              ) : null
                            }
                          <div className='payment-note'>Note: Charges will appear as 'KALEIDOSCOPE GROUP www.mykaleido MN' on your statement.</div>
                        </div>
                      </div>

                        <div className="section group processing-fee-message-text">
                          <div className="col span_12_of_12">
                            {
                              customProcessingVisible && customAmountVisible ? (
                                <div className="form-group config_input">
                                  <div className="form-check">
                                    {/* <input className="field-group__field-full"
                                      name="include_processing_fee"
                                      type="checkbox"
                                      id="defaultCheck1"
                                      checked={include_processing_fee}
                                      onChange={this.handlFieldValueChange}
                                    /> */}

                                    <label className="form-check-label" htmlFor="defaultCheck1">
                                      <span className="message-please-add-processing-fee">{application.processing_fee_description__c || 'A 3% processing fee will be applied to your payment.'}</span>
                                    </label>
                                  </div>
                                </div>
                              ) : null
                            }
                          </div>
                        </div>

                        <div className="section group">
                          <div className="col span_12_of_12">
                            <div className="stripe-confirm-payment-button-container">
                              <CTAButton
                                className={`application__submit-trigger stripe-confirm-payment-button ${(hasAllValues && this.state.total_amount) ? 'active' : ''}`}
                                arrow={true}
                                type="tertiary"
                                disabled={!(hasAllValues && this.state.total_amount > 0)}
                              >
                                {(customAmountVisible) ? `Click to confirm payment ${this.getAmount()}` : `Click to confirm payment ${application.amount_to_pay ? '$'+application.amount_to_pay : ''}`}
                              </CTAButton>
                            </div>

                          </div>
                        </div>
                      </form>
                    ) : null
                  }
                </div>

                <div className="tab-pane fade" id="Recurring" role="tabpanel" aria-labelledby="Recurring-tab">
                  {
                    (currentTab === 'Recurring-tab') ? (
                      <form onSubmit={this.handleSubmit}>
                        <div className="stripe-payment-gateway__container__card-type">
                          <PaymentGatewayVisa className="icon-visa" />
                          <PaymentGatewayMasterCard className="icon-master-card" />
                          <PaymentGatewayDiscover className="icon-discover" />
                          <PaymentGatewayDinersClub className="icon-diners-club" />
                          <PaymentGatewayJCB className="icon-jcb" />
                        </div>
                        <div className="section group">
                          <div className="col span_12_of_12">
                            <div className="payment-msg">{this.state.success}</div>
                          </div>
                        </div>
                        <div className="section group">
                          <div className="col span_6_of_12">
                            <CardSection
                              errors={this.state.errors}
                              updateErrors={this.updateErrors}
                            />
                          </div>

                          <div className="col span_6_of_12">
                            <div className="section group">
                              <div className="col span_6_of_12">
                                <Field
                                  className='field-group__field-full'
                                  type='select'
                                  label='Frequency'
                                  value={frequency}
                                  options={CreateOptions(['day', 'week', 'month', 'year'])}
                                  placeholder='Frequency'
                                  handleChange={(val) => this.onChange('frequency', val)}
                                />
                              </div>

                              <div className="col span_6_of_12">
                                <Field
                                  className='field-group__field-full'
                                  type='select'
                                  label='# of Payments'
                                  value={no_of_payments}
                                  options={CreateOptions(['2', '3', '4', '5'])}
                                  placeholder='Payments'
                                  handleChange={(val) => this.onChange('no_of_payments', val)}
                                />

                              </div>
                            </div>


                            <div className="section group">
                              <div className="col span_12_of_12">
                                <label class="CTAGrey" htmlFor="frequency">First Payment Date</label>
                                <div className="">
                                  <Cleave
                                    placeholder="mm/dd/yyyy"
                                    options={{ date: true, datePattern: ['m', 'd', 'Y'] }}
                                    onChange={this.handlFieldValueChange}
                                    className="form-control"
                                    id="first_payment_date"
                                    name="first_payment_date"
                                  />
                                </div>
                                <span className="form-error is-visible">{errors.first_payment_date}</span>
                              </div>
                            </div>

                          </div>

                          <div className="col span_12_of_12">
                            <div className="btn-group btn-group-toggle" data-toggle="buttons" id="your-amount">
                              <div className="stripe-payment-amount-with-other-option">
                                <div>
                                  <Field
                                    className='field-group__field-full'
                                    type='Radio Button'
                                    label='Your Amount'
                                    value={this.state.otherAmount ? { 'label': 'Other', 'value': 'Other' } : total_amount}
                                    options={CreateOptions(amountOptions)}
                                    placeholder='Frequency'
                                    handleChange={(val) => this.onChangeAmount('total_amount', val, true)}
                                  />
                                </div>
                                <div>
                                  <Field
                                    className='field-group__field-full'
                                    type='Radio Button'
                                    value={this.state.otherAmount ? { 'label': 'Other', 'value': 'Other' } : ''}
                                    options={CreateOptions(['Other'])}
                                    placeholder='Frequency'
                                    label='&nbsp;'
                                    handleChange={(val) => this.handleOtherAmount('total_amount', val)}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>

                          <div className="col span_12_of_12">
                            <Field

                              className='field-group__field-full'
                              type='money'
                              value={`$ ${formatCurrency(total_amount)}`}
                              id="still-employed-by-taco-bell"
                              handleChange={(val) => this.onChangeAmount('total_amount', val, false)}
                              disabled={!this.state.otherAmount}
                            />
                            <div className="">
                              <span className="form-error is-visible">{errors.total_amount}</span>
                            </div>
                          </div>

                          {/* <div className="col span_12_of_12">
                            <p className="message-minimum-online-donation">${application.minimum_donation_amount__c || 0} is the minimum online donation. All donations are tax deductible.</p>
                          </div> */}

                          <div className="col span_12_of_12">
                            <div className="form-check">
                              <input className="form-check-input" name="include_processing_fee" type="checkbox" id="defaultCheck1" checked={include_processing_fee} onChange={this.handlFieldValueChange} />
                              <label className="form-check-label no-margin" htmlFor="defaultCheck1"><span className="message-please-add-processing-fee">{application.processing_fee_description__c || `Please add the processing fee of $${processing_fee_amount} to my total so that the full amount goes towards Print & Graphics SCholarship Foundation.`}</span></label>
                            </div>
                          </div>

                          <div className="col span_12_of_12">
                            <p className="message-you-can-choose-a-recurring-donation">You can choose a recurring donation to be perpetual, or end after a specific number of payments.</p>
                          </div>

                          <div className="col span_12_of_12">
                            <div className="form-check">
                              <input className="form-check-input" name="perpetual" type="checkbox" id="defaultCheck2" checked={perpetual} onChange={this.handlFieldValueChange} />
                              <label className="form-check-label" htmlFor="defaultCheck2"><span className="message-please-add-processing-fee">Perpetual?</span></label>
                            </div>
                          </div>

                          <div className="col span_12_of_12">
                            <div className="stripe-confirm-payment-button-container">
                              <CTAButton
                                className={`stripe-confirm-payment-button application__submit-trigger stripe-sub ${(hasAllValues && this.state.total_amount) ? 'active' : ''}`}
                                arrow={true}
                                type="tertiary"
                                disabled={!(hasAllValues && this.state.total_amount >0)}
                              >
                                Click to confirm payment {this.getAmount()}
                              </CTAButton>
                            </div>
                          </div>
                        </div>

                      </form>
                    ) : null
                  }


                </div>

              </div>

            </div>

          </div>
        </div>
      </fieldset >
    );
  }
}

const PaymentRequestForm = injectStripe(Stripe);


export default class Checkout extends React.Component {
  constructor() {
    super();
    this.state = {
      elementFontSize: window.innerWidth < 450 ? '14px' : '18px',
    };
    window.addEventListener('resize', () => {
      if (window.innerWidth < 450 && this.state.elementFontSize !== '14px') {
        this.setState({ elementFontSize: '14px' });
      } else if (
        window.innerWidth >= 450 &&
        this.state.elementFontSize !== '18px'
      ) {
        this.setState({ elementFontSize: '18px' });
      }
    });
  }

  render() {
    const { elementFontSize } = this.state;
    return (
      <div className="Checkout">
        <Elements>
          <PaymentRequestForm
            title={this.props.title}
            subTitle={this.props.subTitle}
            hideMinimumAmount={this.props.hideMinimumAmount}
            match={'Stripe'}
            application={this.props.application}
            step={this.props.step}
            current_step={this.props.current_step}
            setPaymentAlert={this.props.setPaymentAlert}
            submitPayment={this.props.submitPayment}
            applicationstepid={this.props.applicationstepid}
            setLoading={this.props.setLoading}
            buttonSecondaryColor={this.props.buttonSecondaryColor}
            formType = {this.props.formType}
            validationCheck = {this.props.validationCheck}
            accountData = {this.props.accountData}
            fieldData = {this.props.fieldData}
          />
        </Elements>
      </div>
    );
  }
}
